import { render, staticRenderFns } from "./routeList.vue?vue&type=template&id=3f597be6&scoped=true"
import script from "./routeList.vue?vue&type=script&lang=js"
export * from "./routeList.vue?vue&type=script&lang=js"
import style0 from "./routeList.vue?vue&type=style&index=0&id=3f597be6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f597be6",
  null
  
)

export default component.exports